import { render, staticRenderFns } from "./UserV2.vue?vue&type=template&id=8d6b79ee&scoped=true&"
import script from "./UserV2.vue?vue&type=script&lang=ts&"
export * from "./UserV2.vue?vue&type=script&lang=ts&"
import style0 from "./UserV2.vue?vue&type=style&index=0&id=8d6b79ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6b79ee",
  null
  
)

export default component.exports